import { useStaticQuery, graphql } from "gatsby"

export const QueryImage = () => {
    const { allFile } = useStaticQuery(
    graphql`
      query {
        allFile(filter: {relativeDirectory: {in: "queensberry"}, relativePath: {ne: "queensberry/queensberry2.png"}}, sort: {fields: name}) {
          edges {
            node {
              childImageSharp {
                fluid(quality: 80) {
                  aspectRatio
                  base64
                  sizes
                  src
                  srcSet
                }
              }
            }
          }
        }
      }
    `
    )
    return allFile
}